var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFullScreenBtn)?_c('div',{staticClass:"full-screen-btn-con"},[_c('Tooltip',{attrs:{"content":_vm.value ? '退出全屏' : '全屏',"placement":"bottom"}},[_c('Icon',{attrs:{"color":"#fff","type":_vm.value ? 'md-contract' : 'md-expand',"size":23},nativeOn:{"click":function($event){return _vm.handleChange.apply(null, arguments)}}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }